import React from 'react';
import styled from "styled-components";
import Carousel, {CarouselItem} from '@molecules/swiper/carousel';
import RadiusGenerate from "@helpers/radius.generate";
import Avatar from "@atoms/avatar";
import {isEmpty} from "@helpers/helpers";
import Icon from "@atoms/icon";
import PhoneBlackIcon from '@icons/phone.svg';
import VerifiedBadgeIcon from '@icons/verified-badge.svg';
import VIPIcon from '@icons/vip.svg';
import {getAgencyProfileUrl, getLogo} from "../../../models/agency";
import ButtonBase from "@atoms/button.base";
import {useWindowSize} from "../../helpers/windows.size";

function AgenciesSlider({agencies, className, setContactInfo, sectionTitle = null}) {
    const windowWidth = useWindowSize();

    const breakpoints = {
        1024: {
            slidesPerView: (agencies.length > 4) ? 4.3 : agencies.length,
        },
        768: {
            slidesPerView: 2.4,
        },
        320: {
            slidesPerView: 1.6,
        }
    };

    const vipBadge = (vip) => {
        return vip ? <Icon width={32} height={16} className="vip-icon"><VIPIcon/></Icon> : ''
    }

    return (
        <Container className={" " + (className ?? '')}>
            <p className="mb-16 d-block mx-24 mx-md-0"><strong className="h2 ">{sectionTitle ?? 'املاک منتخب منطقه'}</strong></p>

            <div className="sm-fluid">
                <Carousel className="" breakpoints={breakpoints} pagination={false} navigation_show={(agencies.length > 4)}>
                    {
                        agencies.map((agency, key) => {
                            const profileUrl = getAgencyProfileUrl({
                                agency_username: agency.username,
                                agency_city_name: agency.city_name,
                                agency_district_name: agency.district_name,
                                agency_slug: agency.slug,
                                agency_name: agency.name
                            });
                            const avatarPath = getLogo(agency.id, !isEmpty(agency.updated_at) ? agency.updated_at : '');
                            const isAuthenticated = agency.authenticated;
                            const isVIP = agency.is_vip ?? false;

                            return (
                                <CarouselItem key={key}>
                                    <Card key={key} className={"w-100 d-flex item-card " + ('item-card-count-' + agencies.length)}>
                                        <a href={profileUrl} target="_blank" className="">
                                            <div className="position-relative d-block">
                                                <Avatar size="80" className="agencies-avatar" src={avatarPath} type="agency" alt={agency.name}/>
                                                {vipBadge(isVIP)}
                                            </div>
                                        </a>

                                        <div className="card-item-info text-ellipsis">
                                            <a href={profileUrl} className={"d-flex align-items-center text-ellipsis w-100 " + (agencies.length > 2 ? ' justify-content-center ' : '')} target="_blank">
                                                <h4>{agency.name}</h4>

                                                {
                                                    (isAuthenticated) ?
                                                        <Icon width={16} height={16} className="mr-4"><VerifiedBadgeIcon/></Icon>
                                                        : ''
                                                }
                                            </a>

                                            <Slogan className="d-block text-ellipsis w-100">
                                                {
                                                    (!isEmpty(agency.slogan)) ?
                                                        agency.slogan
                                                        :
                                                        (
                                                            (!isEmpty(agency.city_name) ? (agency.city_name + '، ') : '') +
                                                            (!isEmpty(agency.district_name) ? (agency.district_name + '، ') : '') +
                                                            (!isEmpty(agency.address) ? agency.address : '')
                                                        )
                                                }
                                            </Slogan>
                                        </div>

                                        <ContactButton className="mt-24" size="sm" onClick={() => setContactInfo({show: true, property_id: null, realtor_id: null, agency_id: agency.id, isOnList: true})}>
                                            <Icon width={16} height={16} className="ml-8"><PhoneBlackIcon/></Icon>
                                            {windowWidth > 370 ? 'اطلاعات تماس' : 'تماس'}
                                        </ContactButton>
                                    </Card>
                                </CarouselItem>
                            )
                        })
                    }
                </Carousel>
            </div>
        </Container>
    )
}

export default React.memo(AgenciesSlider);

// styles
const Container = styled.div`
  .swiper-container {
    padding-bottom: 24px;
    margin-bottom: -24px;
  }

  .vip-icon {
    position: absolute;
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Card = styled.div`
  padding: 24px 16px;
  ${RadiusGenerate('8px')};
  border: solid 1px ${props => props.theme.gray200};
  background-color: #ffffff;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .card-item-info {
    width: 100%;
    text-align: center;

    & > a {
      margin-top: 4px;
    }
  }

  &.item-card-count-2 {
    @media (min-width: ${props => props.theme.screenXsMax}) {
      flex-direction: row;
      text-align: right;

      .card-item-info {
        width: auto;
        margin-right: 16px;
        margin-left: 16px;
        text-align: right;

        & > a {
          margin-top: 0;
        }
      }
    }
  }

  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.12);
  }

  img {
    background-color: ${props => props.theme.gray100};
  }

  .text-ellipsis {
    max-width: 100%;
  }
`;

const Slogan = styled.span`
  line-height: 1.8;
  color: #222222;
`;

const ContactButton = styled(ButtonBase)`

  @media (min-width: ${props => props.theme.screenXsMax}) {
    .item-card-count-2 & {
      margin-right: auto;
      margin-top: 0 !important;
      min-width: 144px;
    }
  }

  svg {
    path, g {
      stroke: #ffffff;
      stroke-width: 1.3px;
    }
  }
`;